import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";

const state = {
  categoriesOptions: [],
  categorisDataSearch:{
    data:[],
    meta:{}
  },
  provinces:[],
  distrists:[],
  amphures:[],
  listingAttr:[],
  textSearch:null,
  dataSearch: null,
  isCountMobile:0,
  category:{},
  listing_attr:{},
  suggestList:[],
  categoryTitle: null
};
const getters = {
  categoriesOptions: (state) => state.categoriesOptions,
  categorisDataSearch: (state) => state.categorisDataSearch,
  provinces: (state) => state.provinces,
  distrists: (state) => state.distrists,
  amphures: (state) => state.amphures,
  listingAttr: (state) => state.listingAttr,
  textSearch: (state) => state.textSearch,
  dataSearch: (state) => state.dataSearch,
  isCountMobile: (state) => state.isCountMobile,
  category: (state) => state.category,
  listing_attr: (state) => state.listing_attr,
  suggestList: (state) => state.suggestList,
  categoryTitle: (state) => state.categoryTitle,
};

const actions = {
  [actionType.GET_CATEGORY]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api.get("/categories").then(result => {
        commit(mutationType.LIST_CATEGORY, {
          data: result.data.data
        })
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_DATA_SEARCH_CATEGORY]: async function ({ commit }, param) {
    Object.keys(param).forEach(function(key) {
        if(param[key] == null || param[key] == '')
        {
          delete param[key];
        }
    });
    // let query = '';
    // if(Array.isArray(param.listing_attributes))
    // { 
    //   param.listing_attributes.map((item, index)=>{
    //     if(item.attr_type=="Textbox" && item.value != null && item.value != "")
    //     {
    //       query += `listing_attributes[${index}]=${JSON.stringify(item)}${param.listing_attributes.length== index+1 ? '': '&' }`;
    //     }
    //     if(item.attr_type=="Number" && item.pre_values_id != null)
    //     {
    //       query += `listing_attributes[${index}]=${JSON.stringify(item)}${param.listing_attributes.length== index+1 ? '': '&' }`;
    //     }
    //   })
    // }
    // query +=`coordinates=${JSON.stringify(param.coordinates)}`;
    // delete param.listing_attributes;
    console.log("param",param)
    return new Promise((resolve, reject) => {
      api.post(`listings/search/properties`,
        param
    ).then(result => {
        resolve(result)
        commit(mutationType.SET_DATA_SEARCH_CATEGORY, {
          data: result.data
        })
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_DATA_PROVINCES]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api("/areas/provinces",{
        method: "GET",
        params: params,
      }).then(result => {
        commit(mutationType.SET_DATA_PROVINCES, {
          data: result.data.data
        })
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_DATA_AMPHURES]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api("/areas/amphures",{
        method: "GET",
        params: params,
      }).then(result => {
        commit(mutationType.SET_DATA_AMPHURES, {
          data: result.data.data
        })
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_DATA_DISTRISTS]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api("/areas/districts",{
        method: "GET",
        params: params,
      }).then(result => {
        commit(mutationType.SET_DATA_DISTRISTS, {
          data: result.data.data
        })
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_LISTING_ATTR]: async function ({ commit }, params) {
    return new Promise((resolve, reject) => {
      api("/listing-attributes",{
        method: "GET",
        params: params,
      }).then(result => {
        commit(mutationType.SET_LISTING_ATTR, {
          data: result.data.data
        })
      })
        .catch(error => reject(error));
    });
  },
  [actionType.GET_TEXT_SEARCH]: async function ({ commit }, textSearch) {
    commit(mutationType.SET_TEXT_SEARCH, textSearch)
  },
  [actionType.GET_ID_ATTR]: async function ({ commit }, data) {
    console.log(data)
    commit(mutationType.SET_ID_ATTR, {data: data})
  },
  "GET_IS_COUNT_MOBILE": async function ({ commit }) {
    commit("SET_IS_COUNT_MOBILE")
  },
  "GET_LIST_SUGGEST": async function ({ commit },params) {
    return new Promise((resolve, reject) => {
      api("/listings/search/suggestion",{
        method: "GET",
        params: params,
      }).then(result => {
        commit("SET_SUGGEST_LIST", result.data.data)
      })
        .catch(error => reject(error));
    });
  },
};


const mutations = {
  [mutationType.LIST_CATEGORY](state, data) {
    data.data.forEach((element)=>{
      
      if(element.listing_category_children.length){
        element.hasChild= true;
        element.expanded= false;
        element.listing_category_children.forEach((subElement)=>{
          if(state.dataSearch&&subElement.id==state.dataSearch.id){
            subElement.isChecked=true;
            element.expanded= false;
          }
          if(subElement.listing_category_children.length){
            subElement.hasChild= true;
            subElement.expanded= false;
          }else{
            subElement.hasChild= false;
            subElement.expanded= false;
          }
        })
      }else{
        element.hasChild= false;
        element.expanded= false;
      }
    })
    state.categoriesOptions = data.data
  },
  [mutationType.SET_DATA_SEARCH_CATEGORY](state, data) {
    if(data.data.data.length >= 1)
    {
      data.data.data.splice(Math.floor(Math.random() * data.data.data.length),0,{
          showGoogleAds:true,
          price: null,
          title: null,
          province: {
            name: null
          },
          district: {
            name: null
          },
          url_feature_image: null,
          id: null,
          listing_premiums: []
      })
    }
    state.categorisDataSearch.data = data.data.data;
    state.categorisDataSearch.meta = data.data.meta;
  },
  [mutationType.SET_DATA_PROVINCES](state, data) {
    state.provinces = data.data
  },
  [mutationType.SET_DATA_AMPHURES](state, data) {
    state.amphures = data.data
  },
  [mutationType.SET_DATA_DISTRISTS](state, data) {
    state.distrists = data.data
  },
  [mutationType.SET_LISTING_ATTR](state, data) {
    state.listingAttr = data.data
  },
  [mutationType.SET_TEXT_SEARCH](state, data) {
    state.textSearch = data
  },
  [mutationType.SET_ID_ATTR](state, data) {
    state.dataSearch = {
      id: data.data.value,
      title: data.data.title
    }
  },
  "SET_IS_COUNT_MOBILE"(state) {
    state.isCountMobile = state.isCountMobile +1;
  },
  "SET_CATEGORY"(state,data) {
    state.category = data
  },
  "SET_CHECK_LISTING_ATTR"(state,data) {
    state.listing_attr = data;
  },
  "SET_EMPTY_FILLTER"(state) {
    state.category = {},
    state.listing_attr = {}
  },
  "SET_SUGGEST_LIST"(state,data){
    state.suggestList = data
  },
  "SET_TITLE_SEARCH"(state, data){
    state.categoryTitle = data
  },
  "SET_NULL_TITLE_SEARCH"(state){
    state.categoryTitle = null
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}